import { Link } from 'react-router-dom'

export default function Forbidden() {
  return (
    <div className="pt-[72px] min-h-screen bg-brand-offwhite flex flex-col items-center justify-center text-center px-6">
      <div className="max-w-md flex flex-col items-center gap-6">
        <div className="h-20 w-20 rounded-full bg-brand-sand/50 flex items-center justify-center text-brand-dark text-3xl shadow-inner">
          <i className="fa-light fa-shield-keyhole" />
        </div>
        <h1 className="text-5xl font-serif font-bold text-brand-dark">403</h1>
        <h2 className="text-xl font-serif font-semibold text-brand-dark/80">Adgang nægtet</h2>
        <p className="text-sm text-brand-gray/60 leading-relaxed">
          Du har ikke tilladelse til at tilgå denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os.
        </p>
        <Link
          to="/"
          className="bg-brand-dark hover:bg-brand-dark/90 text-brand-offwhite text-xs font-semibold uppercase tracking-wider px-8 py-4 rounded-full transition-all duration-200 hover:shadow-lg active:scale-95 mt-2"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  )
}
